import React, { Component } from 'react';
import './TappableComponentsHeader.scss';

const TappableComponentsHeader = ({ customerData, locationIndex, stays }) => {
    const tourDetails = stays ? stays[locationIndex] : customerData;

	/**
	 * Returns a truncated date range based on the start and end dates
	 * provided in the object that gets passed in.
	 *
	 * @param {Object} details
	 */
    const formatDates = () => {
        const monthNames = [
            'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
            'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
        ];
        const startDate = new Date(tourDetails.StartDate);
        const endDate = new Date(tourDetails.EndDate);
        const startDay = startDate.getDate();
        const endDay = endDate.getDate();
        const startMonth = monthNames[startDate.getMonth()];
        const endMonth = monthNames[endDate.getMonth()];

        return `${startMonth} ${startDay} ${'\u2013'} ${endMonth} ${endDay}`;
    };

    return (
        <header className='tappable-components__header'>
            <h2 className='tappable-components__header__date'>{formatDates()}</h2>
        </header>
    );
};

export default TappableComponentsHeader;



// WEBPACK FOOTER //
// ./application/components/TappableComponentsHeader/TappableComponentsHeader.jsx